// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"496c85c9","196":"750ebb15","222":"491ab18c","252":"89606460","417":"09257dcb","478":"42ecf5e2","582":"2e302d14","624":"3507b690","682":"deb8804e","778":"daf47f98","822":"ec2c8628"}[chunkId] + ".chunk.js";
};